"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationMultidimensional_1 = require("./AnimationMultidimensional");
var AnimationObject_1 = require("../AnimationObject");
var AnimationTransform = (function (_super) {
    tslib_1.__extends(AnimationTransform, _super);
    function AnimationTransform(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        if (_this._rawData.a) {
            _this.anchorPoint = new AnimationMultidimensional_1.AnimationMultidimensional(_this._rawData.a, version);
        }
        if (_this._rawData.p) {
            _this.position = new AnimationMultidimensional_1.AnimationMultidimensional(_this._rawData.p, version);
        }
        if (_this._rawData.s) {
            _this.scale = new AnimationMultidimensional_1.AnimationMultidimensional(_this._rawData.s, version);
        }
        if (_this._rawData.r) {
            _this.rotation = new AnimationMultidimensional_1.AnimationMultidimensional(_this._rawData.r, version);
        }
        if (_this._rawData.o) {
            _this.opacity = new AnimationMultidimensional_1.AnimationMultidimensional(_this._rawData.o, version);
        }
        if (_this._rawData.sk) {
            _this.skew = new AnimationMultidimensional_1.AnimationMultidimensional(_this._rawData.sk, version);
        }
        if (_this._rawData.sa) {
            _this.skewAxis = new AnimationMultidimensional_1.AnimationMultidimensional(_this._rawData.sa, version);
        }
        return _this;
    }
    return AnimationTransform;
}(AnimationObject_1.AnimationObject));
exports.AnimationTransform = AnimationTransform;
//# sourceMappingURL=AnimationTransform.js.map